<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.name"
                  label="Name"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.name'),
                      serverSideErrors('Name')
                    )
                  "
                  @blur="$v.form.name.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <client-select
                  :error-messages="
                    [].concat(
                      fieldErrors('form.clientId'),
                      serverSideErrors('ClientId')
                    )
                  "
                  v-model="form.clientId"
                  label="Select Client"
                  @blur="$v.form.clientId.$touch()"
                />
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  type="number"
                  v-model="form.rate"
                  label="Pay Rate"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.rate'),
                      serverSideErrors('Rate')
                    )
                  "
                  @blur="$v.form.rate.$touch()"
                />
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <v-select
                  v-model="form.type"
                  :items="typeOptions"
                  item-text="text"
                  item-value="value"
                  label="Type"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.type'),
                      serverSideErrors('Type')
                    )
                  "
                  @blur="$v.form.type.$touch()"
                />
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="form.description"
                  label="Description"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.description'),
                      serverSideErrors('Description')
                    )
                  "
                  @blur="$v.form.description.$touch()"
                  rows="1"
                  auto-grow
                  required
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Save" : "Add" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import UTIL from "src/helpers/utility";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";

import ClientSelect from "components/ClientSelect.vue";

const defaultInputs = {
    id: "",
    clientId: "",
    name: "",
    description: "",
    rate: 0,
    type: ""
};

export default {
  components: {
    AlertMessage,
    ClientSelect,
  },
  props: {

    clientId: Number,
    item: Object,
    show: [Boolean, String],
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: {
        required,
      },
      type: { required },
      clientId: { required },
      description: {  },
      rate: { required },
    },
  },
  validationMessages: {
    form: {
      name: {
        required: "Required",
      },
      type: {
        required: "Required",
      },
      description: {
        required: "Required",
      },
      clientId: {
        required: "Required",
      },
      rate: {
        required: "Required",
      },
    },
  },

  data() {
    return {
      showDialog: this.show,

      form: {
        ...defaultInputs,
      },

      typeOptions: [
        { value: "remote", text: "Remote Support" },
        { value: "onsite", text: "Onsite Support" },
      ],

      statusOptions: [
        { value: "open", text: "Open" },
        { value: "closed", text: "Closed" },
      ],

      dialog: false,
      valid: false,
      loading: false,
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },

    item(n, o) {
      if (n && JSON.stringify(n) !== JSON.stringify(o)) {
        this.form = {
          ..._.pick(n, _.keys(defaultInputs)),
        };
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      timeclock: (state) => state.timeclock,
      alert: (state) => state.alert,
    }),
    formTitle() {
      return this.isEdit ? "Edit Job" : "Add Time Clock";
    },
    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },
    timeclockId() {
      return UTIL.gv(this.item, "id", "");
    },
  },

  methods: {
    ...mapActions("timeclock", ["create", "update"]),

    initForm() {
      if (this.clientId) {
        this.form = { 
            ...defaultInputs,
            clientId: this.clientId
        };
      }
    },

    serverSideErrors(field) {
      return UTIL.gv(this.timeclock.errors, field, []);
    },
    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$nextTick(() => {
        // clear error state
        this.$store.dispatch("alert/clear");
        this.$v.$reset();
      });

      this.initForm();
    },

    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        ...defaultInputs,
      };
    },
    completed() {
      this.$emit("onSucceded");
    },
    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let payload = {
        ...this.form,
      };

      if (this.isEdit) {
        await this.update({
          id: this.timeclockId,
          ...payload,
          completed: this.item.completed
        });
      } else {
        delete payload.id;
        await this.create(payload);
      }

      if (!this.timeclock.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>